module.exports = __webpack_public_path__ + "8caa20efb85203eb291a038096524ac6.pdf";